import { Selector, State, StateContext } from '@ngxs/store';
import { Receiver, EmitterAction } from '@ngxs-labs/emitter';
import { Injectable } from '@angular/core';

export interface AppInfoModel {
  tenancyName?: string;
  userNameOrEmailAddress?: string;
  darkMode?: boolean;
  themePalette?: 'professional' | 'legacy-green';
  version?: string;
}

@State<AppInfoModel>({
  name: 'appInfo',
  defaults: { darkMode: false, themePalette: 'professional' }
})
@Injectable()
export class AppInfoState {

  @Selector()
  static darkMode(state: AppInfoModel): boolean {
    return state.darkMode;
  }

  @Selector()
  static themePalette(state: AppInfoModel): 'professional' | 'legacy-green' {
    return state.themePalette || 'professional';
  }

  @Receiver()
  static setAppInfo({ getState, patchState }: StateContext<AppInfoModel>,
    { payload }: EmitterAction<AppInfoModel>) {
    const state = { ...getState(), ...payload }
    patchState(state);
  }

  @Receiver()
  static setTheme(
    { patchState }: StateContext<AppInfoModel>,
    { payload }: EmitterAction<boolean>) {
    patchState({ darkMode: payload });
  }

  @Receiver()
  static setThemePalette(
    { patchState }: StateContext<AppInfoModel>,
    { payload }: EmitterAction<'professional' | 'legacy-green'>) {
    patchState({ themePalette: payload });
  }
}
